const cardItems = [
  {
    id: 1,
    title: '《深海回响》治愈系动画长片',
    desc: '水墨画风与3D技术的完美结合，讲述一段关于成长与告别的温暖故事，年度最受期待的国产动画。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20underwater%20scene%20with%20soft%20golden%20light%20rays%20penetrating%20deep%20blue%20ocean%2C%20flowing%20ink%20wash%20painting%20style%2C%20delicate%20bubbles%20and%20marine%20life%20silhouettes%2C%20dreamy%20atmosphere%2C%20warm%20amber%20light%20highlights&width=800&height=500&seq=card-01-beiwo&orientation=landscape',
    tag: '动画',
    rating: '9.2',
  },
  {
    id: 2,
    title: '《极寒风暴》动作冒险大片',
    desc: '零下四十度的极地绝境，一场关乎生存的极限挑战。IMAX特制画幅，打斗场面拳拳到肉。',
    img: 'https://readdy.ai/api/search-image?query=Arctic%20landscape%20with%20dramatic%20snow%20covered%20mountains%20under%20golden%20sunset%20light%2C%20ice%20formations%20glowing%20with%20warm%20amber%20hues%2C%20extreme%20wilderness%20atmosphere%2C%20cinematic%20widescreen%2C%20adventure%20film%20aesthetic&width=800&height=500&seq=card-02-beiwo&orientation=landscape',
    tag: '动作',
    rating: '8.7',
  },
  {
    id: 3,
    title: '《恋与星空》浪漫爱情电影',
    desc: '两个天文学家在观测站相遇，在星辰大海的见证下展开一段跨越光年的浪漫爱情。',
    img: 'https://readdy.ai/api/search-image?query=Starry%20night%20sky%20above%20an%20observatory%20dome%20with%20warm%20golden%20interior%20light%20spilling%20out%2C%20milky%20way%20visible%2C%20telescope%20silhouette%2C%20romantic%20atmosphere%2C%20soft%20warm%20tones%2C%20cinematic%20composition&width=800&height=500&seq=card-03-beiwo&orientation=landscape',
    tag: '爱情',
    rating: '8.5',
  },
  {
    id: 4,
    title: '《代号：破晓》谍战悬疑剧',
    desc: '潜伏、暗杀、密码战，一个被遗忘的特工代号，牵扯出冷战时期最惊心动魄的秘密行动。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%201960s%20European%20street%20at%20dusk%20with%20warm%20amber%20street%20lamps%2C%20mysterious%20silhouette%20in%20trench%20coat%20walking%20on%20cobblestone%2C%20old%20architecture%2C%20film%20noir%20spy%20thriller%20atmosphere&width=800&height=500&seq=card-04-beiwo&orientation=landscape',
    tag: '悬疑',
    rating: '9.0',
  },
  {
    id: 5,
    title: '《美食猎人》旅行美食综艺',
    desc: '跟着美食猎人走遍中国大江南北，寻找那些藏在街头巷尾的绝妙味道，治愈你的胃和心。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20bustling%20Chinese%20night%20market%20with%20colorful%20lanterns%20and%20steaming%20food%20stalls%2C%20golden%20lighting%2C%20sizzling%20street%20food%20closeup%2C%20rich%20amber%20and%20red%20tones%2C%20cozy%20atmosphere%2C%20food%20documentary%20style&width=800&height=500&seq=card-05-beiwo&orientation=landscape',
    tag: '综艺',
    rating: '8.9',
  },
  {
    id: 6,
    title: '《机械纪元》硬核科幻系列',
    desc: '人工智能觉醒后的未来世界，人类与机器之间的边界变得模糊。三部曲一次看完。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20neon%20lights%20and%20holographic%20displays%2C%20warm%20amber%20and%20copper%20metallic%20surfaces%2C%20advanced%20technology%20aesthetic%2C%20cyberpunk%20atmosphere%20with%20soft%20golden%20glow%2C%20cinematic%20sci-fi%20composition&width=800&height=500&seq=card-06-beiwo&orientation=landscape',
    tag: '科幻',
    rating: '9.1',
  },
  {
    id: 7,
    title: '《荒野之歌》自然纪录大片',
    desc: 'BBC级别制作水准，历时三年跨越七大洲拍摄，用4K超清镜头记录地球上最壮美的生命奇迹。',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20golden%20hour%20savanna%20landscape%20with%20acacia%20trees%20silhouette%2C%20wild%20animals%20in%20distance%2C%20warm%20sunset%20colors%20painting%20the%20sky%2C%20documentary%20cinematography%2C%20rich%20earthy%20amber%20and%20crimson%20tones&width=800&height=500&seq=card-07-beiwo&orientation=landscape',
    tag: '纪录',
    rating: '9.5',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Picks</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            编辑团队为你精选的优质内容，部部都是口碑佳作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {cardItems.slice(0, 7).map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer hover:border-accent-300/40 transition-all duration-300 hover:-translate-y-1">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2 py-1 bg-black/55 backdrop-blur-sm text-white text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-1 bg-accent-500 text-white text-xs font-bold rounded-md whitespace-nowrap">
                  {item.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-1" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}